export * from './useTruncateText';
import useTruncateText from './useTruncateText';
export default useTruncateText;
